import { httpGet, httpPost } from "@eres/rest";
import cfg from "./config";
import { REQ_SOURCE_DLD_WEB, ValidationError } from "@eres/rtregistrationapi/entities";
import { I8N, StringUtil } from "@eres/core";
import { OwnerVIPRequest } from "./entities";
import { TabuRequestApi } from "@10x/tabu-mobile-api";
import { TabuDoc } from "@my-dld/screens/TabuRequest/BaseTabuRequestForm";

export function getOwnerCategoryDetails( participantId: number ) {
	return httpGet( cfg.vipOwnerAPI().endPoint() + `GetCategoryDetail/${ participantId }/${ participantId }` ).then( r => {
		return validateResponse( r );
	} );
}

export function getVIPOwnerRequests( participantId: number ) {
	return httpGet( cfg.vipOwnerAPI().endPoint() + `GetRequestDetail/${ participantId }/${ participantId }` ).then( r => {
		return validateResponse( r );
	} );
}

export function saveVIPOwnerRequest( request: OwnerVIPRequest, participantId: number ) {
	return httpPost( cfg.vipOwnerAPI().endPoint() + `SaveRequest/${ participantId }`, request ).then( r => {
		return validateResponse( r );
	} );
}

export function updateVIPOwnerRequest( reqId: number, statusId: number, participantId: number ) {
	return httpGet( cfg.vipOwnerAPI().endPoint() +
		`UpdateRequestStatus/${ reqId }/${ statusId }/${ REQ_SOURCE_DLD_WEB }/${ participantId }` ).then( r => {
		return validateResponse( r );
	} );
}

export function uploadDocuments( docs: TabuDoc[] ): Promise<any> {
	let uploadTasks: Promise<TabuDoc>[] = [];
	for ( let doc of docs ) {
		if ( doc.fileUrl && !StringUtil.isEmptyStringOrNull( doc.fileUrl ) ) {
			uploadTasks.push( Promise.resolve( doc ) );
		} else {
			if ( doc && doc.localData ) {
				let localData = doc.localData;
				let extData = localData.split( ";" )[ 0 ];
				let type = extData.includes( "image" ) ? "jpg" : "pdf";
				let encoded = localData.replace( /^data:(.*;base64,)?/, "" );
				if ( ( encoded.length % 4 ) > 0 ) {
					encoded += "=".repeat( 4 - ( encoded.length % 4 ) );
				}
				uploadTasks.push( TabuRequestApi.uploadTabuDocument( encoded, type ).then( ( response ) => {
						doc.fileUrl = response.Response.DocumentPath;
						return Promise.resolve( doc );
					} ).catch( ( reason ) => {
						return Promise.reject( reason );
					} )
				);
			} else {
				uploadTasks.push( Promise.resolve( doc ) );
			}
		}
	}
	return Promise.all( uploadTasks );
}

function validateResponse<T>( response: any ): Promise<T> {
	if ( response == undefined ) {
		return Promise.reject( "Empty response" );
	} else if ( response.Errors && response.Errors.length > 0 ) {
		let reason = getValidationError( response.Errors );
		return Promise.reject( reason );
	} else if ( response.ResponseEntity !== undefined ) {
		let resp = response.ResponseEntity;
		if ( resp.Errors && resp.Errors.length > 0 ) {
			let reason = getValidationError( response.Errors );
			return Promise.reject( reason );
		}
	}
	return Promise.resolve( response.ResponseEntity );
}

function getValidationError( errors: ValidationError[] ) {
	let errorMsg = errors.map( ( error: ValidationError ) => {
		let nameEn = !StringUtil.isEmptyStringOrNull( error.ErrorMessage ) ? error.ErrorMessage :
			error.ErrorMessageAr;
		let nameAr = !StringUtil.isEmptyStringOrNull( error.ErrorMessageAr ) ? error.ErrorMessageAr : nameEn;
		return I8N.isRTL() ? nameAr : nameEn;
	} );
	return errorMsg.join( "\n" );
}
